WiseMetering.Views.ResetPassword = WiseMetering.Views.Modal.Custom.extend({
    buttons: ['yes', 'no'],
    className: 'mbx-info',
    template: 'templates/users/reset_password',
    width: 650,
    title: () => i18next.t('modal.title.users.reset_password'),

    yes: function() {
        this.block();
        this.model.resetPassword(
            function() {
                WiseMetering.layout.showTipper('success', i18next.t('users.password_reset_success'));
                this.close();
            }.bind(this),
            function() {
                WiseMetering.layout.showTipper('error', i18next.t('users.error_message'));
                this.close();
            }.bind(this)
        ).then(() => {
            this.options.callback();
        });
    }
});
